import React from 'react';

import { Media } from '$partials/media/index.js';
import { Meta } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').HoldingPage}
 */
const HoldingPage = (props) => {
    const page = props.data.page;

    if (page?.media?.image) {
        page.media.image.loadingStyle = {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        };
    }

    return (
        <>
            <Meta
                description={props.data?.page?.searchDescription || props.data?.page?.listingText}
                domain={props.domain}
                image={props.data?.page?.listingImage}
                page={props.data?.page} />

            <main className='layout-container'>
                <div className='sm:h-dvh sm:overflow-hidden sm:flex sm:flex-col'>
                    <div className='mt-24 sm:my-auto'>
                        <div className='layout-grid flex flex-wrap'>
                            <div className='hidden sm:block sm:w-1/12' />

                            <div className='w-6/12 sm:w-4/12 layout-grid-col'>
                                {page?.media && (
                                    <figure className='pointer-events-none select-none'>
                                        <Media { ...page.media} />
                                    </figure>
                                )}
                            </div>

                            <div className='hidden sm:block sm:w-1/12' />

                            <div className='w-full sm:w-4/12 layout-grid-col sm:flex sm:flex-col mt-50 sm:mt-0'>
                                <h1 className='sr-only'>ColourWorks</h1>

                                <div
                                    className='rich-text type-style-heading flex flex-col gap-26 sm:gap-36'
                                    dangerouslySetInnerHTML={{ __html: page?.heading }} />

                                {(page?.bookingCtaUrl && page?.bookingCtaLabel) && (
                                    <p className='my-40 sm:my-50'>
                                        <a
                                            className='button'
                                            href={page.bookingCtaUrl}
                                            rel='noreferrer'
                                            target='_blank'>
                                            {page.bookingCtaLabel}
                                        </a>
                                    </p>
                                )}

                                <div className='flex flex-col mt-auto'>
                                    <div className='sm:flex sm:gap-x-16 sm:order-2 mt-90 sm:mt-38'>
                                        <div className='sm:w-1/2'>
                                            <div
                                                className='rich-text type-style-body'
                                                dangerouslySetInnerHTML={{ __html: page?.contactSocials }}/>
                                        </div>

                                        <div className='sm:w-1/2'>
                                            <address
                                                className='rich-text type-style-body not-italic'
                                                dangerouslySetInnerHTML={{ __html: page?.contactAddress }}/>
                                        </div>
                                    </div>

                                    <div className='sm:order-1 mt-24 sm:mt-150'>
                                        <h2 className='type-style-body'>
                                            {page?.newsletterHeading || 'Sign up for news and launch updates'}
                                        </h2>

                                        <form
                                            action='https://lockstudios.us1.list-manage.com/subscribe/post?u=e75375356b3b7d00bf23d4b8f&amp;id=5343919b87&amp;f_id=00623be5f0'
                                            className='flex items-center gap-12 mt-12'
                                            method='post'
                                            name='mc-embedded-subscribe-form'>
                                            <input
                                                name='b_e75375356b3b7d00bf23d4b8f_5343919b87 '
                                                type='hidden'
                                                value= ''/>

                                            <input
                                                id='gdpr_365658'
                                                name='gdpr[365658]'
                                                type='hidden'
                                                value='Y'/>

                                            <label
                                                className='sr-only'
                                                htmlFor='frm-email'>
                                                Email
                                            </label>

                                            <input
                                                required
                                                className='form-input'
                                                id='frm-email'
                                                name='EMAIL'
                                                placeholder='Email'
                                                type='text' />

                                            <button
                                                className='button-hollow'
                                                type='submit'>
                                                Submit
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HoldingPage;
